export default {
    breadcrumbs: {
        referrals: 'Referrals pool',
        received: 'Received',
        made: 'Made',
    },
    miles_away: 'miles away',
    your_proposed_slots: 'Your proposed time slots:',
    you_did_not_propose: 'You did not propose time slots',
    choose_provider: 'Please choose provider and confirm time slot',
    update_patient_choose_provider: 'Please update patient information and confirm time slot',
    select_referral_slots: 'Select Appointment Slot',
    required_fields_error: 'Please fill out all required fields.*',
    propose_time: 'Propose time',
    current_referral: 'Current referral',
    send_to_patient_provider: 'Send to patient and provider',
    selected_slots: 'Selected time slots:',
    please_select_3_time_slots: 'Please select 3 time slots to schedule your patient',
    accept_and_propose_time: 'Accept and propose time',
    constrained_modal_check_again: 'Check again',
}
